import { CommonService } from './../../../shared/services/common.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { AuthfakeauthenticationService } from 'src/app/core/services/authfake.service';
import { EventService } from 'src/app/core/services/event.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
declare var $: any;

interface Product {
  name: string;
  quantity: number;
  src: string;
}
@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {
  id = JSON.parse(localStorage.getItem('currentUser')).id
  userToken = JSON.parse(localStorage.getItem('currentUser')).user_token
  nameDevice = JSON.parse(localStorage.getItem('selectedProduct'))?.name

  products: Product[] = [
    { name: 'wifi', quantity: 1, src: 'assets/images/loa_wifi.png' },
    { name: '4g', quantity: 1, src: 'assets/images/loa_4g.png' },
    { name: '4g_old', quantity: 1, src: 'assets/images/loa_4g_old.png' },
  ];
  // create-payment
  quantity: number = 1
  listType
  type = -1
  referrer: ''
  address: ''
  dataAddress
  selectedProvince: any = -1;
  selectedDistrict: any = -1;
  selectedWard: any = -1;
  quantityFlag: boolean = false
  serviceType: string | null = null;
  currentSection: number = 0;
  sectionValue
  productLocal
  isCancelModalOpen = false;
  isDirectModalOpen = false;
  constructor(
    private commonService: CommonService,
    private authService: AuthenticationService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
    private apiService: ApiService,
    private translateService: TranslateService,
    public authenticationService: AuthenticationService,
    public authFackservice: AuthfakeauthenticationService,

  ) { }

  ngOnInit(): void {
    this.productLocal = JSON.parse(localStorage.getItem('selectedProduct'))

    this.route.queryParams.subscribe(params => {
      this.sectionValue = +params['section'];
      if (this.sectionValue === 2) {
        this.currentSection = this.sectionValue;
      } else {
        if (this.sectionValue === 1) {
          this.currentSection = this.sectionValue;
        } else {
          this.currentSection = 0;
        }
      }
    });
    this.fetchData()
    this.setActiveProduct(this.activeProduct ? this.activeProduct : this.products[0])

  }
  isPlaying = false;
  audio = new Audio('assets/audio/File_test.mp3');
  playAudio() {
    if (this.isPlaying) {
      this.audio.pause();
      this.isPlaying = false;
    } else {
      this.audio.play();
      this.isPlaying = true;
      this.audio.onended = () => {
        this.isPlaying = false;
      };
    }
  }

  //modal 
  openCancelModal() {
    this.isCancelModalOpen = true;
  }
  
  closeCancelModal() {
    this.isCancelModalOpen = false;
  }
  openDirectModal() {
    this.isDirectModalOpen = true;
  }
  
  closeDirectModal() {
    this.isDirectModalOpen = false;
  }


  //choose package

  onCheckboxChange(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    if (!checkbox.checked) {
      checkbox.checked = true;
    }
  }

  onBack() {
    Swal.fire({
      text: this.translateService.instant('Bạn có chắc chắn muốn đóng ứng dụng?'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#141ED2',
      cancelButtonColor: 'fff',
      confirmButtonText: this.translateService.instant('FORM.WarningConfirm'),
      cancelButtonText: this.translateService.instant('FORM.Cancel'),
      customClass: {
        icon: 'my-custom-icon-class'
      }
    }).then(result => {
      if (result.value) {
        this.authFackservice.logoutMobile();

        setTimeout(() => {
          if (window['ReactNativeWebView']) {
            window['ReactNativeWebView'].postMessage(JSON.stringify({
              type: 'GO_BACK',
            }));
            console.log('Message posted to React Native WebView');
          } else {
            console.warn('ReactNativeWebView không tồn tại. Sử dụng môi trường local để test.');
            window['ReactNativeWebView'] = {
              postMessage: (message) => {
                console.log('Message posted to React Native (mock):', message);
              }
            };
            window['ReactNativeWebView'].postMessage(JSON.stringify({
              type: 'GO_BACK',
            }));
          }
        }, 2000);
      }
    });

  }
  updateQuantity(product: any, value: string) {
    const quantity = Math.max(1, Number(value)); 
    this.quantities[product.name] = quantity; 
    this.selectedProduct.quantity = quantity; 
  }
  selectedPackage: number | null = null;
  packages
  selectedPackageId: number | null = 2;
  selectPackage(packageId: number) {
    if (this.selectedPackageId === packageId) {
      this.selectedPackageId = null;
    } else {
      this.selectedPackageId = packageId;
    }
  }

  toWorkspace() {
    this.router.navigate(['/account/workspace-mobile']);
  }
  previousSection() {
    if (this.sectionValue === 1) {
      this.router.navigate(['/viettel/create-qr']);
    }
    if (this.currentSection > 0) {
      this.currentSection--;
    }
  }

  sectionTitles = [
    'Thông tin giao hàng',
    'Thông tin cửa hàng',
    'Thông tin người nhận',
    'Địa chỉ nhận hàng',
    'Xác nhận thanh toán'
  ];
  nextSection() {
    if (this.currentSection < this.sectionTitles.length - 1) {
      this.currentSection++;
    }
  }
  selectedProduct: { name: string; quantity: number, src: any } | null = null;
  quantities: { [key: string]: number } = {
    'wifi': 1,
    '4g': 1,
  };

  selectProduct(product: any) {
    this.selectedProduct = product;

    $('#chooseDetails').modal('show');


  }
  activeProduct: Product = this.products.find(product => product.name === this.nameDevice) || null;
  isFirstCall = true;
  setActiveProduct(product: Product): void {
    if (this.isFirstCall && this.sectionValue === 2) {
      this.activeProduct = product;
      this.selectedProduct = {
        name: product.name,
        quantity: this.productLocal?.quantity,
        src: product.src
      };
      this.isFirstCall = false;

    } else {
      this.activeProduct = product;
      this.selectedProduct = {
        name: product.name,
        quantity: this.quantities[product.name],
        src: product.src
      };
    }
    this.selectedPackageId = product.name === '4g' ? 5 : 2;
  }

  changeQuantity(product: Product, change: number): void {
    console.log(this.selectedProduct.name);

    const newQuantity = this.quantities[product.name] + change;
    if (newQuantity >= 1 && newQuantity <= 10) {
      this.quantities[product.name] = newQuantity;
      if (this.activeProduct?.name === product.name) {
        this.selectedProduct.quantity = newQuantity;
      }
    }
  }


  fetchData() {
    const name = JSON.parse(localStorage.getItem('selectedProduct'))?.name
    this.apiService.getList('service-package?device_name=' + name
    ).subscribe({
      next: (res) => {
        this.packages = res['metadata']['packages'] ? res['metadata']['packages'] : [];
      }
    })

  }
  validateQuantity() {
    if (this.quantity > 100) {
      this.quantityFlag = true
    }
    else {
      this.quantityFlag = false

    }
  }
  onSubmit() {
    if (this.type == -1) {
      this.apiService.showToastMobile(
        this.translateService.instant('warning'),
        this.translateService.instant('Cần nhập đầy đủ thông tin')
      );
      return;
    }
    if (this.quantity > 100) {
      this.apiService.showToastMobile(
        this.translateService.instant('warning'),
        this.translateService.instant("Số lượng vượt quá giới hạn")
      );
      return;
    }
    const data = {
      packageId: this.type,
      quantity: this.quantity,
      referrer: this.referrer,
      deliveryMethod: this.serviceType
    }
    this.apiService.postItem('customer-service-package', data).subscribe({
      next: (res: any) => {
        setTimeout(() => {
          this.router.navigate(['/account/workspace-mobile']);
        }, 3000)
        if (window['ReactNativeWebView']) {
          window['ReactNativeWebView'].postMessage(JSON.stringify({
            type: 'PAYMENT_HUB_TRANSACTION',
            data: {
              merchant: {
                code: res.metadata.merchant_code,
                name: res.metadata.merchant_name,
              },
              type: {
                code: res.metadata.type_code,
                name: res.metadata.type_name,
                allowCard: true,
              },
              id: res.metadata.transaction_id,
              amount: res.metadata.amount,
              description: res.metadata.description,
              successMessage: res.metadata.successMessage
            }
          }))
        } else {
          console.log("Thanh toán thành công");
        }

      },
      error: e => {
        if (e == 'Customer already has this package qr paybox') {
          this.apiService.showToastMobile('error', this.translateService.instant('Tài khoản đã sử dụng gói dịch vụ'))
        } else {
          this.apiService.showToastMobile('error', this.translateService.instant('Đăng ký thất bại'))
        }
        this.eventService.setLoading(false)
      }
    })
  }

  handleOffline() {
    localStorage.setItem('serviceType', 'direct')
    this.router.navigate(['/account/form-page']).then(() => {
      document.querySelector('.modal-backdrop')?.remove();
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
    });

  }

  handleOnline() {
    localStorage.setItem('serviceType', 'shipper')
    this.router.navigate(['/account/form-page']).then(() => {
      document.querySelector('.modal-backdrop')?.remove();
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
    });
  }

  saveToLocalStorage(): void {
    if (this.selectedProduct) {
      this.nextSection()
      localStorage.setItem('selectedProduct', JSON.stringify(this.selectedProduct));
      this.fetchData()
    } else {
      console.log("No product selected.");
    }
  }
  registerService(): void {
    if (this.selectedProduct && this.selectedPackageId) {
      const selectedPackage = this.packages.find(pkg => pkg.id === this.selectedPackageId);
      if (selectedPackage) {
        const totalCost = selectedPackage.discountedPrice + (this.selectedProduct.quantity);
        const registrationData = {
          product: this.selectedProduct,
          package: selectedPackage,
          totalCost: totalCost
        };

        localStorage.setItem('registrationData', JSON.stringify(registrationData));
      }
    } else {
      console.log("Vui lòng chọn sản phẩm và gói dịch vụ.");
    }
  }
}
